import React from "react";
import { graphql, useFragment } from "react-relay";

import { faRectangleHistory } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useFilterRecordingsByCompany } from "~/recordings/Filters/hooks/useFilterRecordingsByCompany";
import Menu from "~/ui/menu";

import { type AbstractAction, ActionButton } from "./shared";

import type { FilterByCompany_note$key } from "~/__generated__/FilterByCompany_note.graphql";

import suggestedActionsStyles from "./SuggestedActions.module.css";

const ACTION_ID = "filter-by-company" as const;

const noteFragment = graphql`
	fragment FilterByCompany_note on Note {
		externalAttendeeDomains
	}
`;

export function useNoteExternalDomains({ note: noteKey }: { note: FilterByCompany_note$key }) {
	const note = useFragment(noteFragment, noteKey);
	return note.externalAttendeeDomains;
}

interface FilterByCompanyProps {
	domain?: string;
}

function Button(props: FilterByCompanyProps) {
	const { domain } = props;

	// Ideally domain would be a required prop, but that doesn't work with the way SuggestedActions is implemented.
	// We're removing SuggestedActions soon, so this is an okay workaround for now.
	const onFilterByCompany = useFilterRecordingsByCompany(domain ?? "", "/library");

	if (!domain) return null;

	return (
		<ActionButton actionId={ACTION_ID} onClick={onFilterByCompany}>
			<FontAwesomeIcon icon={faRectangleHistory} size="sm" className={suggestedActionsStyles.actionButtonIcon} />
			View <b>&nbsp;{domain}&nbsp;</b> meetings
		</ActionButton>
	);
}

function MenuItem(props: FilterByCompanyProps) {
	const { domain } = props;

	const onFilterByCompany = useFilterRecordingsByCompany(domain ?? "", "/library");

	if (!domain) return null;

	return (
		<Menu.Item icon={faRectangleHistory} iconProps={{ size: "sm" }} onSelect={onFilterByCompany}>
			View <b>&nbsp;{domain}&nbsp;</b> meetings
		</Menu.Item>
	);
}

export default {
	id: ACTION_ID,
	button: Button,
	menuItem: MenuItem,
} satisfies AbstractAction;
